import { ProductColor, VariantDetails, VariantsByKey } from '../../../../integrations/relewise/types/mapped';
import { RelewiseMappingService } from '../../../../integrations/relewise/services/MappingService';

interface GetSelectedVariantArgs {
    productItemId: string | undefined;
    variantsByKey: VariantsByKey | undefined;
    compatibleSizesByColor: Record<string, string[]> | undefined;
    activeColor: ProductColor | undefined;
    activeSize: string | undefined;
    relewiseMappingService: RelewiseMappingService;
}

export const getSelectedVariant = ({
    productItemId,
    variantsByKey,
    compatibleSizesByColor,
    activeColor,
    activeSize,
    relewiseMappingService
}: GetSelectedVariantArgs): VariantDetails | undefined => {
    if (!productItemId || !variantsByKey || !activeColor) {
        return undefined;
    }
    const sizes = compatibleSizesByColor?.[activeColor.name] ?? [];
    const sizeForLookup = activeSize ?? sizes[0];
    if (!sizeForLookup) {
        return undefined;
    }
    const variantKey = relewiseMappingService.mapProductDimensionsToRelewiseVariantId(productItemId, activeColor.name, sizeForLookup);
    return variantsByKey[variantKey];
};
